import React, { FC, useEffect, useRef, useState } from 'react';
import { Paper } from '@mantine/core';
import classNames from 'classnames';

import styles from './styles.module.scss';
import { useMediaQuery } from '@mantine/hooks';

interface StickyBarProps {
  children?: React.ReactNode;
  className?: string;
}

const StickyBar: FC<StickyBarProps> = ({ children, className }) => {
  const isMediumDevice = useMediaQuery('(max-width: 992px)');
  const [topOffset, setTopOffset] = useState(0);
  const height = useRef(0);
  const observedDiv = useRef<HTMLElement | null>(null);
  const headerHeight = 78;

  useEffect(() => {
    const elem = document.getElementById('main-navigtaion');
    if (elem) {
      observedDiv.current = elem as HTMLElement;
    }
  }, []);

  useEffect(() => {
    if (!observedDiv.current) {
      return;
    }

    const resizeObserver = new ResizeObserver(() => {
      if (observedDiv?.current?.offsetHeight !== height.current) {
        height.current = observedDiv?.current?.offsetHeight as number;

        const mainNavSize = observedDiv?.current?.getBoundingClientRect();
        if (mainNavSize?.height) {
          setTopOffset(mainNavSize.height + headerHeight);
        }
      }
    });

    resizeObserver.observe(observedDiv.current);

    return function cleanup() {
      resizeObserver.disconnect();
    };
  }, [observedDiv.current]);

  return (
    <Paper
      className={classNames(styles.upperBar, className)}
      style={!isMediumDevice && topOffset ? { top: topOffset } : {}}
      shadow="none"
      p="md"
      px={24}>
      {children}
    </Paper>
  );
};

export default StickyBar;
